import { withPrefix } from "gatsby";
import React, { FunctionComponent, useContext, useState } from "react";
import { LoginButton } from "../components/buttons";
import { AuthLink, GatedLink } from "../components/links";
import { StyledNavbar } from "../components/styled";
import Context from "../context/Context";
import { useEventContext } from "../context/EventProvider";
import { useGatedLinkModalContext } from '../context/GatedLinkModalProvider';
import useEventDetails from "../hooks/useEventDetails";
import { CloseIcon, HamburgerIcon } from "./icons";
import { Facebook, LinkedIn, MailOutline, X } from "@mui/icons-material";

import ModalCPE from "../components/modals/cpeModal";

const Navbar: FunctionComponent = (props: any, { onToggle }) => {
  const { event: { url, email, emailSubject } } = useEventContext();
  const { setActiveModal } = useGatedLinkModalContext();
  const { virtual, eventEndTime } = useEventDetails();
  const [state, setState] = useState(false);
  const data = useContext(Context);
  const { navPagesDefault, navPagesSingle, socialShare, activeLink } = data;
  const navData = virtual ? navPagesSingle : navPagesDefault;
  const showHide = () => {
    onToggle && onToggle(!state);
    setState(!state);
  };
  const closeNav = () => {
    setState(false);
    onToggle && onToggle(false);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <StyledNavbar>
      <div className="toggleContainer">
        <div className="togBtn">
          <a
            onClick={showHide}
            className={`navTogglebtnOpen ${state ? "open" : "close"}`}
          >
            <CloseIcon />
          </a>
          <button
            onClick={showHide}
            className={`navTogglebtnClose ${state ? "close" : "open"}`}
          >
            <HamburgerIcon />
          </button>
        </div>
      </div>
      <a href={withPrefix("/")} onClick={closeNav}>
        <img
          src="https://cdn.ems.prod.upgather.com//uploads/aitalks_navlock_up_02f667939d.svg"
          alt="AITalks Logo"
          className="event-slogan-logo"
        />
      </a>
      <div className={`pages ${state ? "open" : "close"}`}>
        {true &&
          navData
            // .filter((page) => page.disabled !== true)
            .map((page, index: number) => {
              const showLink =
                page.showAfterEvent === undefined ||
                page.showAfterEvent === null ||
                (page.showAfterEvent && eventEndTime < Date.now()) ||
                (!page.showAfterEvent && eventEndTime > Date.now());

              if (!showLink) {
                /*return null;*/
              }
              const activeClass = activeLink === page.name ? "active-link" : "";
              if (page.disabled) {
                return (
                  <GatedLink
                    key={index}
                    to={page.path}
                    className={`page ${activeClass}`}
                    target={page.target}
                    closeNav={closeNav}
                  >
                    {page.name}
                  </GatedLink>
                );
              } else if (page.auth) {
                return (
                  <AuthLink
                    key={index}
                    to={page.path}
                    className={`page ${activeClass}`}
                    target={page.target}
                  >
                    {page.name}
                  </AuthLink>
                );
              }else if (
                page.path == "/cpe"
              ) {
                return (
                  <a
                    key={index}
                    target={page.target}
                    className={`page cpe ${activeClass}`}
                    onClick={() => { openModal(); }}
                  >
                    {page.name}
                  </a>
                  
                );
              } else if (
                page.path &&
                page.path.startsWith(("mailto", "mailto"))
              ) {
                return (
                  <a
                    key={index}
                    href={page.path}
                    target={page.target}
                    className={`page ${activeClass}`}
                    onClick={() => { setActiveModal(null); closeNav(); }}
                  >
                    {page.name}
                  </a>
                );
              } else {
                let path =
                  page.path && page.path.startsWith(("https", "https"))
                    ? page.path
                    : withPrefix(page.path);
                return (
                  <a
                    key={index}
                    href={path}
                    target={page.target}
                    className={`page ${activeClass}`}
                    onClick={() => { setActiveModal(null); closeNav(); }}
                  >
                    {page.name}
                  </a>
                );
              }
            })
            .filter(Boolean)}
        <LoginButton className="page login" closeNav={closeNav} />
        <ModalCPE isOpen={modalOpen} onClose={closeModal}>

                  <b className="cpebold">2024 Google Public Sector Summit</b> attendees are eligible to receive continuing professional education (CPE) credits. Attendees can earn a maximum of 4 CPE credits in information technology.<br /><br />
                  In order to verify your CPEs, please document your name on the CPE attendance sheet located at the registration desk onsite. Be sure to return to the registration desk to document your time out. If sign in and/or sign out times are not documented, FedScoop is unable to verify your attendance and therefore cannot award CPE credit.<br /><br />
                  <b className="cpebold">Additional details:</b><br />
                  <b className="cpebold">Delivery Method:</b> Group-Live<br />
                  <b className="cpebold">Program Level:</b> Intermediate<br />
                  <b className="cpebold">Prerequisites:</b> Previous professional experience in IT and technology is recommended for all participants<br />
                  <b className="cpebold">Advance Preparation:</b> No advance preparation necessary<br />
                  <b className="cpebold">Contact:</b>  <a href="mailto:kylie.galyen@scoopnewsgroup.com" target="_blank" className="cpe-email">Kylie Galyen</a> for details on obtaining CPE credits at the event.<br /><br />
    
                  <img src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/trellix/2023/cybersecurity-summit/CPElogo.jpg" className="cpe-image" alt="CPE" /><p className="sngcpe">Scoop News Group is registered with the National Association of State Boards of Accountancy (NASBA) as a sponsor of continuing professional education on the National Registry of CPE Sponsors. State boards of accountancy have final authority on the acceptance of individual courses for CPE credit. Complaints regarding registered sponsors may be submitted to the National Registry of CPE Sponsors through its website: <a href="https://www.nasbaregistry.org" target="_blank" className="cpe-nasbar">www.NASBARegistry.org</a>.</p>
                  </ModalCPE>
        <div className="social-nav-container">
          {socialShare.map((social, index: number) => {
            const IconRender = () => {
              switch (social.alt) {
                case "facebook":
                  return <Facebook color="red" />;
                case "twitter":
                  return <X />;
                case "linkedin":
                  return <LinkedIn />;
                case "email":
                  return <MailOutline />;
                default:
                  return null;
              }
            };
            return (
              <a
                key={index}
                className="social-icon"
                href={
                  social.alt === "email"
                    ? `${social.path}${email}?subject=${emailSubject}`
                    : `${social.path}${url}`
                }
                target={"_blank"}
                onClick={() => { closeNav(); }}
              >
                {IconRender()}
              </a>
            );
          })}
        </div>
      </div>
    </StyledNavbar>
  );
};

export default Navbar;
